<template>
  <div id="b-map" class="fullheight b-map-root">
    <layer-controls></layer-controls>
    <div id="redbook-map" ref="map"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LayerControls from '@/components/LayerControls.vue';

import { MARKER_ICON_BY_ID } from '@/constants/markerIcons';
import { loadGoogleMaps } from '@/services/googleMaps';
import { SET_MAP, SET_MARKERS } from '@/store/actions.type';

function initMap(center, mapEl) {
  let customMapType = new google.maps.StyledMapType(
    [
      {
        stylers: [
          { visibility: 'simplified' },
          { saturation: -100 },
          { gamma: 0.8 },
        ],
      },
      {
        featureType: 'poi.business',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'poi.medical',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'water',
        stylers: [{ color: '#667799' }],
      },
      {
        featureType: 'poi.park',
        stylers: [{ color: '#cadcc0' }],
      },
      {
        featureType: 'road.arterial',
        stylers: [{ color: '#ebb666' }],
      },
      {
        featureType: 'road.highway',
        stylers: [{ color: '#ebb666' }],
      },
      {
        featureType: 'road.local',
        stylers: [{ color: '#ebdcc6' }],
      },
    ],
    {
      name: 'Archnadzor Style',
    }
  );

  let customMapTypeId = 'archnadzor_style';

  const googleMap = new google.maps.Map(mapEl, {
    center,
    zoom: 13,
    mapTypeControl: false,
    mapTypeControlOptions: {
      mapTypeIds: [google.maps.MapTypeId.ROADMAP, customMapTypeId],
    },
  });

  googleMap.mapTypes.set(customMapTypeId, customMapType);
  googleMap.setMapTypeId(customMapTypeId);
  return googleMap;
}

function setMarkers(buildings, problems, onMarkerClick) {
  let images = {};
  for (let id = 1; id <= problems.length; id++) {
    const url = MARKER_ICON_BY_ID[id] || MARKER_ICON_BY_ID[1];
    images[id] = {
      url: `${url}?v=0.1`,
      size: new google.maps.Size(50, 60),
      anchor: new google.maps.Point(20, 60),
      // origin: new google.maps.Point(50 * i, 0)
    };
  }

  return function (map) {
    return buildings.map((item) => {
      let problemId = parseInt(item.problemId);
      let marker = new google.maps.Marker({
        position: {
          lat: parseFloat(item.lat),
          lng: parseFloat(item.lng),
        },
        map,
        title: item.title,
        id: item.id,
        icon: images[problemId],
      });
      marker.problemId = problemId;
      marker.addListener('click', onMarkerClick.bind(null, marker));
      return marker;
    });
  };
}

export default {
  name: 'GoogleMap',
  components: {
    LayerControls,
  },
  data() {
    return {
      map: null,
      onCenterAndZoomLocation: null,
    };
  },
  computed: {
    ...mapGetters(['center', 'markers', 'buildings', 'problems', 'eventBus']),
  },
  methods: {
    onMarkerClick(item) {
      const { id } = item;

      let zoom = parseInt(this.$route.query.zoom, 10);

      let query = {};
      if (zoom) query.zoom = zoom;
      if (this.$route.query.problemid) {
        query.problemid = this.$route.query.problemid;
      }

      this.$router.push({ path: `/map/${id}`, query }, () => {});
      this.eventBus.$emit('marker-click', id);
    },
    updateUrl(zoom) {
      const url = new URL(window.location.href);
      url.searchParams.set('zoom', zoom);
      window.history.replaceState({}, document.title, url.toString());
    },
  },
  async mounted() {
    try {
      await loadGoogleMaps();
    } catch (error) {
      console.error('[redbook] Failed to initialize Google Maps', error);
      return;
    }
    this.map = initMap(this.center, this.$refs.map);
    google.maps.event.addListener(this.map, 'zoom_changed', () => {
      const zoom = this.map.getZoom();
      this.updateUrl(zoom);
    });
    this.$store.commit(SET_MAP, this.map);
    let markers = setMarkers(
      this.buildings,
      this.problems,
      this.onMarkerClick
    )(this.map);
    this.$store.commit(SET_MARKERS, markers);
    this.onCenterAndZoomLocation = ({ zoom, lat, lng }) => {
      this.map.setZoom(zoom);
      this.map.panTo(new google.maps.LatLng(lat, lng));
    };
    this.eventBus.$on('center-and-zoom-location', this.onCenterAndZoomLocation);
  },
  beforeDestroy() {
    if (this.onCenterAndZoomLocation) {
      this.eventBus.$off('center-and-zoom-location', this.onCenterAndZoomLocation);
    }
    this.$store.commit(SET_MAP, null);
    this.$store.commit(SET_MARKERS, []);
  },
};
</script>

<style>
.b-map-root {
  padding-right: 0;
}
</style>
